import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { ComponentSize } from '../../declarations/common.decl';
import { FormContext } from './context';

var Form = function Form(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? ComponentSize.REGULAR : _ref$size,
      children = _ref.children,
      otherFormProps = _objectWithoutPropertiesLoose(_ref, ["size", "children"]);

  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      size: size
    }
  }, /*#__PURE__*/React.createElement("form", otherFormProps, children));
};

export default Form;